import SectionHeading from "./SectionHeading";

const STEPS = [
  {
    number: "01",
    icon: "ri-scan-line",
    title: "피부 진단",
    desc: "정밀 장비와 육안 검사로 현재 피부 상태를 꼼꼼하게 진단합니다.",
  },
  {
    number: "02",
    icon: "ri-draft-line",
    title: "맞춤 설계",
    desc: "피부 고민과 목표에 맞는 최적의 프로그램을 설계합니다.",
  },
  {
    number: "03",
    icon: "ri-hand-heart-line",
    title: "전문 관리",
    desc: "전문 관리사의 세심한 손길로 집중 관리를 진행합니다.",
  },
  {
    number: "04",
    icon: "ri-home-heart-line",
    title: "사후 케어",
    desc: "관리 후 피부 상태를 확인하고 홈케어 방법을 안내합니다.",
  },
];

export default function Process() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100/60">
      <div className="max-w-6xl mx-auto flex flex-col gap-12">
        <SectionHeading
          eyebrow="Process"
          title="비앙카의 관리 과정"
          description="진단부터 사후관리까지, 체계적인 4단계 프로세스로 완성도 높은 관리를 제공합니다."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((step, index) => (
            <div
              key={step.number}
              className="relative flex flex-col items-center gap-4 p-7 rounded-2xl bg-white border border-background-200/70 text-center"
            >
              {index < STEPS.length - 1 && (
                <span className="hidden lg:block absolute top-1/2 -right-4 text-foreground-300 z-10">
                  <i className="ri-arrow-right-line text-xl"></i>
                </span>
              )}
              <div className="relative">
                <span className="w-16 h-16 rounded-full bg-primary-50 flex items-center justify-center">
                  <i className={`${step.icon} text-3xl text-primary-500`}></i>
                </span>
                <span className="absolute -top-1 -right-1 w-7 h-7 rounded-full bg-primary-500 text-white text-xs font-bold flex items-center justify-center">
                  {index + 1}
                </span>
              </div>
              <div className="flex flex-col gap-1.5">
                <h3 className="text-base font-semibold text-foreground-900">{step.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}